import intersectionHelper from '../../../general/js/intersection-helper';
import BaseComponent from '../../../general/js/base-component';
import stylesFinally from '../../../general/js/style-observer';

export default class AboutSectionComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        stylesFinally(() => {
            this.init();
        });
    }

    init() {
        intersectionHelper.enterViewportOnce(this.element, this.animate.bind(this), {rootMargin: '-25% 0px -20% 0px'});
    }

    animate() {
        this.element.classList.add('is-visible');
    }
}



// WEBPACK FOOTER //
// ./app/components/about/js/about-section.component.js